import { Typography, Button } from "antd";
import { Draggable } from "react-beautiful-dnd";

const { Title } = Typography;

const TemplateItem = ({
  template,
  index,
  editMode,
  isDragging,
  onTemplateSelect,
  onEditTemplate
}) => {
  const htmlEntities = {
    "&nbsp;": " ",
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&apos;": "'",
  };

  const getPlainText = (html) => {
    let content = html.replace(
      /&(nbsp|amp|lt|gt|quot|apos);/g,
      (match, entity) => htmlEntities[`&${entity};`] || match
    );
    return content
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<li>/gi, "\n• ")
      .replace(/<[^>]+>/g, "")
      .replace(/\n\s+/g, "\n\n")
      .trim();
  };

  return (
<Draggable 
  draggableId={template._id} 
  index={index}
  isDragDisabled={!editMode}
>
  {(provided, snapshot) => (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      style={{
        ...provided.draggableProps.style,
        cursor: editMode ? 'grab' : 'pointer',
        borderRadius: '8px',
        marginBottom: '8px',
        padding: '8px 12px',
        background: snapshot.isDragging ? '#e6f7ff' : 'white',
        border: '1px solid #f0f0f0',
        display: 'flex',
        alignItems: 'center',
        transition: 'background 0.2s ease',
      }}
      className="template-item"
      onMouseEnter={(e) => e.currentTarget.style.background = snapshot.isDragging ? '#e6f7ff' : '#f0f7ff'} 
      onMouseLeave={(e) => e.currentTarget.style.background = snapshot.isDragging ? '#e6f7ff' : 'white'}
    >
      {editMode && (
        <div style={{ marginRight: '8px', color: '#999' }}>
          <i className="fas fa-grip-vertical" />
        </div>
      )}

      <Title 
        level={5} 
        style={{ 
          margin: 0,
          flex: 1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '11px',
        }}
        onClick={() => {
          if (editMode) return;
          onTemplateSelect(getPlainText(template.description));
        }}
      >
        {template.title}
      </Title>

      {editMode && (
        <Button 
          type="text" 
          icon={<i className="fas fa-edit" />} 
          onClick={(e) => {
            e.stopPropagation();
            onEditTemplate(template);
          }}
          style={{ marginLeft: '8px' }}
        />
      )}
    </div>
  )}
</Draggable>


  );
};

export default TemplateItem;